import React from 'react'
import { WrapperSelect } from './styles'

export const Search = (props) => {
  return <WrapperSelect {...props} />
}
